import React from 'react';
import { useAuth } from '@/lib/auth';
import Hero from './landing/Hero';
import {
  SocialProof, HowItWorks, Features, Showcase,
  Testimonials, PricingSection, FAQ, FinalCTA,
} from './landing/sections';
import InteractiveDemo from './landing/premium/InteractiveDemo';
import BeforeAfterSlider from './landing/premium/BeforeAfterSlider';
import ROICalculator from './landing/premium/ROICalculator';
import UseCases from './landing/premium/UseCases';
import FeatureComparison from './landing/premium/FeatureComparison';
import Trust from './landing/premium/Trust';
import './landing/landing.css';

const Landing = () => {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-[#050505] text-white" data-testid="landing-page">
      <Hero user={user} />
      <SocialProof />
      <InteractiveDemo />
      <HowItWorks />
      <BeforeAfterSlider />
      <ROICalculator />
      <UseCases />
      <Features />
      <FeatureComparison />
      <Showcase />
      <Testimonials />
      <Trust />
      <PricingSection user={user} />
      <FAQ />
      <FinalCTA user={user} />
    </div>
  );
};

export default Landing;
